import React from "react";
import { useSelector } from "react-redux";

import styles from "./modals.module.scss";
import NewChatModalComponent from "./new-chat/new-chat.component";
import ChatFolderModalComponent from "./chat-folder/chat-folder.component";
import NewChatServiceModalComponent from "./new-chat-services/new-chat-services.component";
import ChatSelectedFolderSettingComponent from "./chat-folder/chat-selected-folders-setting/chat-selected-folders-setting.component";
import ChatSelectFoldersComponent from "./chat-folder/chat-select-folders/chat-select-folders.component";

import { ApplicationStore } from "~/app/application.store";

const ModalsComponent: React.FC = () => {
  const newChatModalIsOpen: boolean = useSelector((state: ApplicationStore) => state.modals.newChatModalIsOpen);
  const newChatServiceModalIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.newChatServiceModalIsOpen
  );
  const chatFolderModalIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatFolderModalIsOpen
  );
  const chatSelectFoldersModalIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatSelectFoldersModalIsOpen
  );
  const setChatSelectFolderSettingModalIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatSelectFolderSettingModalIsOpen
  );

  return (
    <div className={styles.modalsComponent}>
      {newChatModalIsOpen && <NewChatModalComponent />}
      {newChatServiceModalIsOpen && <NewChatServiceModalComponent />}
      {chatFolderModalIsOpen && <ChatFolderModalComponent />}
      {chatSelectFoldersModalIsOpen && <ChatSelectFoldersComponent />}
      {setChatSelectFolderSettingModalIsOpen && <ChatSelectedFolderSettingComponent />}
    </div>
  );
};

export default ModalsComponent;
